module.exports = __webpack_public_path__ + "img/prod-hob.eb447ca8.jpg";